export default {
  methods: {
    calculateProductListPrice({rseq1, rseq2, rseq3, rseq4, rseq5}, qty = null, rate = 1, is_shipping_included = false) {
      if(!qty || Number(qty) <= 0) {return Number(0).toFixed(2)}
      // variable assign
      const quantity_needed = Number(qty)
      const fx_rate = Number(rate)
      const rm_cost_per_kg = Number(rseq1) * quantity_needed
      const overheads = Number(rseq2)
      const sundry_cost_per_kg = Number(rseq3) * quantity_needed
      const gross_margin = Number(rseq4)
      const shipping_price_per_kg = rseq5 ? Number(rseq5) : 0
      // end of variable assign

      // start of calculation
      const before_margin_total_per_kg = (rm_cost_per_kg + overheads + sundry_cost_per_kg) / quantity_needed
      const list_price = before_margin_total_per_kg * (1 / (1 - gross_margin / 100))
      return Number((list_price + (is_shipping_included ? shipping_price_per_kg : 0 )) * fx_rate).toFixed(2)
    },
    bespokeAndContractPriceCalculator(price_details, input_quantity) {
        const quantity = Number(input_quantity)
        let price;
        price_details.forEach((item, index) => {
          const max = Number(item.to)
          const min = Number(item.from)
          let matches = false
          if (index > 0 && price_details[index - 1] && Number(price_details[index - 1].to) === min) {
            matches = quantity > min && quantity <= max
          } else {
            matches = quantity >= min && quantity <= max
          }
          if(matches) {
            price =  Number(item.price) * quantity
          }
        })
        return Number(price).toFixed(2)
    },
    calculateGrossMargin({ rseq1, rseq2, rseq3, rseq4, rseq5 }, quantity, price, is_shipping_cost_enable = false, rate = 1) {
      if(!price || !quantity || Number(quantity) <= 0) { return '0' }
      const quantity_needed = Number(quantity)
      const rm_cost_per_kg = Number(rseq1) * quantity_needed
      const overheads = Number(rseq2)
      const sundry_cost_per_kg = Number(rseq3) * quantity_needed
      const retail_target_input = Number(price)
      const shipping_cost = Number(rseq5)
      const fx_rate = Number(rate)
      
      const before_margin_total_per_kg = ((rm_cost_per_kg + overheads + sundry_cost_per_kg) / quantity_needed) + ( is_shipping_cost_enable ? shipping_cost : 0 )
      const margin_made_at_this_price = retail_target_input - (before_margin_total_per_kg * fx_rate)
      return Number((margin_made_at_this_price / retail_target_input) * 100).toFixed(2)
    },
    // these for convert sample per KG price to per Grams and vice versa
    kgToGrams(value) {
      return this.__removeTrailingZeros((Number(value) / 1000).toFixed(4));
    },
    gramsToKg(value) {
      return this.__removeTrailingZeros((Number(value) * 1000).toFixed(4));
    }
  },
}
